import React, { useEffect } from "react";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MailOutline from "@material-ui/icons/MailOutline";
import Swal from 'sweetalert2'
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import { useNavigate } from "react-router-dom";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { CircularProgress, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import isEqual from 'lodash/isEqual';
import { toast } from "react-toastify";
const useStyleData = makeStyles(stylesData);

const useStyles = makeStyles(styles);
const validationSchema = Yup.object({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  nickName: Yup.string(),
  email: Yup.string().email("Invalid email").required("Required"),
  mobileNumber: Yup.string(),
  country: Yup.string(),
  state: Yup.string(),
  city: Yup.string(),
  address: Yup.string(),
  ZipCode: Yup.string(),
  password: Yup.string().min(6, "At least 6 characters"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match'),
  status: Yup.string().required("Required"),
});

export default function EditUser() {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const userId = searchParams.get("userId");

  const [alert, setAlert] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [isFormChanged, setIsFormChanged] = React.useState(false)
  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    nickName: "",
    email: "",
    password: "",
    confirmPassword: "",
    userType: "",
    mobileNumber: "",
    country: "",
    state: "",
    city: "",
    address: "",
    ZipCode: "",
    status: "true",
    dob: null,
    walletKey: {
      publicKey: "",
      privateKey: ""
    }
  });
  console.log(initialValues, "initialValuesinitialValues")

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {

      setLoading(true);
      try {
        const token = localStorage.getItem("token");

        const response = await axios.patch(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/updateEndUserById?id=${userId}`,
          values,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          toast.success(response.data.message, { autoClose: 3000 });
          setInitialValues(values);
          navigate("/admin/userManagement", { state: { shouldRefetch: true } });
        }
      } catch (err) {
        console.error("Update failed:", err);
        toast.error("Failed to update user.");
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    const hasChanged = !isEqual(formik.values, initialValues);
    setIsFormChanged(hasChanged);
  }, [formik.values, initialValues]);
  useEffect(() => {
    const fetchUser = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getendusersid?id=${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const user = res.data.data;
        const formatted = {
          ...user,
          status: String(user.status),
          confirmPassword: user.password,
          dob: user.dob ? new Date(user.dob) : null,
        };
        setInitialValues(formatted);
      } catch (err) {
        console.error("Error loading user:", err);
        toast.error("Failed to load user.");
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [userId]);

  console.log(formik.values, "formik.valuesformik.values")

  // Wallet recharge state & handler
  const [rechargeAmount, setRechargeAmount] = useState("");
  const [rechargeLoading, setRechargeLoading] = useState(false);

  const handleRecharge = async () => {
    const publicKey = initialValues?.walletKey?.publicKey || formik.values?.walletKey?.publicKey;
    if (!publicKey) {
      toast.error("Public key not available");
      return;
    }
    if (!rechargeAmount || Number(rechargeAmount) <= 0) {
      toast.error("Enter a valid amount");
      return;
    }
    setRechargeLoading(true);
    try {
      const token = localStorage.getItem("token");
      const payload = {
        amount: String(rechargeAmount),
        publicKey,
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/depositBalanceViaPublicKey`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        toast.success(res.data.message || "Wallet recharged", { autoClose: 3000 });
        setRechargeAmount("");
      } else {
        toast.error("Recharge failed");
      }
    } catch (err) {
      console.error("Recharge error:", err);
      toast.error(err?.response?.data?.message || "Recharge failed");
    } finally {
      setRechargeLoading(false);
    }
  };
  const classes = useStyles();
  const classesSweetAlert = useStyleData();

  const hideAlert = () => {
    setAlert(null);
    navigate(`/admin/userManagement`, {
      state: { shouldRefetch: true },
    });
  };

  const renderInput = (label, id, type = "text") => (
    <GridItem xs={12} sm={12} md={3}>
      <CustomInput
        labelText={label}
        id={id}
        error={formik.touched[id] && Boolean(formik.errors[id])}
        helperText={formik.touched[id] && formik.errors[id]}
        formControlProps={{ fullWidth: true }}
        inputProps={{
          value: formik.values[id],
          type
        }}
        handleChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
    </GridItem>
  );

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Edit Player</h4>
            </CardHeader>
            <CardBody>
              <form onSubmit={formik.handleSubmit}>
                <GridContainer>
                  {renderInput("First Name", "firstName")}
                  {renderInput("Last Name", "lastName")}
                  {renderInput("Nick Name", "nickName")}
                  {renderInput("Email Id", "email")}
                  <GridItem xs={12} sm={12} md={3} style={{ marginTop: "12px" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="DOB"
                        value={formik.values.dob}
                        onChange={(date) => formik.setFieldValue("dob", date)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            error={formik.touched.dob && Boolean(formik.errors.dob)}
                            helperText={formik.touched.dob && formik.errors.dob}

                          />
                        )}
                      />
                    </LocalizationProvider>
                  </GridItem>


                  {renderInput("Contact Number", "mobileNumber", "number")}
                  {renderInput("Country", "country")}
                  {renderInput("State", "state")}
                  {renderInput("City", "city")}
                  {renderInput("Address", "address")}
                  {renderInput("Zip Code", "ZipCode")}
                  {renderInput("Password", "password", "password")}
                  {renderInput("Confirm Password", "confirmPassword", "password")}


                  <GridItem xs={12} sm={12} md={3} style={{ marginTop: "12px" }}>
                    <FormControl fullWidth className={classes.selectFormControl}>
                      <InputLabel className={classes.selectLabel}>Status</InputLabel>
                      <Select
                        id="status"
                        name="status"
                        value={formik.values.status}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.status && Boolean(formik.errors.status)}
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                      >
                        <MenuItem value={"true"}>Active</MenuItem>
                        <MenuItem value={"false"}>InActive</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>

                  {alert}
                </GridContainer>

            


                {!loading ? (
                  <Button color="rose" type="submit" className={classes.registerButton} disabled={!isFormChanged}>
                    Save
                  </Button>
                ) : (
                  <div className={classes.registerButton}>
                    <CircularProgress size={24} color="inherit" />
                  </div>
                )}
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h4 className={classes.cardIconTitle}>Wallet Recharge</h4>
                <span style={{ fontSize: 12, opacity: 0.9, marginTop: 4 }}>
                  Use the public key below to recharge the user's wallet. Amount accepts decimal values.
                </span>
              </div>
            </CardHeader>
            <CardBody>
              <GridContainer>
               
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Recharge Amount"
                    id="rechargeAmount"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      value: rechargeAmount,
                      type: "number",
                      step: "0.01",
                      min: "0",
                    }}
                    handleChange={(e) => setRechargeAmount(e.target.value)}
                    helperText="Enter amount (e.g. 1.50)"
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3} style={{ display: "flex", alignItems: "flex-end" }}>
                  <Button
                    color="rose"
                    onClick={handleRecharge}
                    disabled={rechargeLoading}
                    fullWidth
                  >
                    {rechargeLoading ? <CircularProgress size={20} color="inherit" /> : "Recharge Wallet"}
                  </Button>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>


    </>
  );
}
